import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { TableWrapper, Badge, Filters, SliderOverlay, ConfirmModal } from "../../component/common"
import { MappingActivityModal } from "../../component/activity"
import { createTravelExperienceGroup, getTravelExperienceGroupListDetails, editTravelExperienceGroup, deleteTravelExperienceGroup } from "../../redux/actions/master"
import { getSNo } from "../../services/helperFunctions"

import {
	getCategoryMappingListDetails,
	getCategoryMappingDropDown,
	deleteActivityMapping
} from "../../redux/actions/activity"

import { LoaderWrapper } from "../../HOC"

class MappingActivityClass extends Component {

	state = {
		headerDetails: [
			{
				label: 'S.No',
			},
			{
				label: 'Activity',
			},
			{
				label: 'Category',
			},
			{
				label: 'CityList',
			},
			{
				label: 'Status',
			},
			{
				label: 'Action'
			},

		],
		filter: [


			{
				label: 'Active',
				value: 1
			},
			{
				label: 'Deactive',
				value: 4
			}

		],
		mappingActivityLists: {

		},
		selectedFilter: 'Active',
		mappingDetails: {
			activity_id: '',
			category_id: '',
			city_list_id: ''

		},

		isError: false,
		isOpen: false,
		isEdit: false,
		ConfirmModalOpenStatus: false,
		id: '',
		activityList: [],
		categoryList: [],
		cityList: [],
		details: {
			activity_id: '',
			category_id: '',
			city_list_id: ''
		},
	}

	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentDidMount() {
		let { mappingActivityLists, categoryMappingDropDownLists: { Activity = [], Category = [], City = [] } } = this.props

		let { activityList, categoryList, cityList } = this.state

		Activity.forEach(item => {
			activityList.push({
				label: item.title,
				value: item.id
			})

		})
		Category.forEach(item => {
			categoryList.push({
				label: item.title,
				value: item.id
			})

		})
		City.forEach(item => {
			cityList.push({
				label: item.city_name,
				value: item.id
			})

		})


		this.setState({
			mappingActivityLists
		})

	}


	requestStatus = (status) => {

		if (status === 1) {
			return <Badge
				type={1}
				label={"Active"}
			/>
		} else if (status === 2) {
			return <Badge
				type={2}
				label={"Deactive"}
			/>
		}

	}

	handleFilter = (query, value, name) => {

		if (name == "filter") {
			this.setState({
				selectedFilter: query
			})

			query = {
				pageNo: 1,
				filter: query
			}
		}

		this.props.getCategoryMappingListDetails(query)



	}


	handleAdd = () => {

		let temp = {
			activity_id: '',
			category_id: '',
			city_list_id: ''
		}
		this.setState({
			isOpen: true,
			mappingDetails: temp
		})
	}



	handleEdit = (index) => {

		let { mappingActivityLists } = this.props

		let { list = [] } = mappingActivityLists

		let mappingDetails = list[index]

		let {
			activity_id,
			category_id,
			city_list_id,
			id,
		} = mappingDetails;

		let details = {

			activity_id,
			category_id,
			city_list_id,
			id,

		}

		this.setState({
			isEdit: true,
			mappingDetails,
			currentIndex: index,
			details,
		})

		this.toggle("isOpen")

	}

	toggle = item => {
		this.setState(prevState => ({
			[item]: !prevState[item]
		}));
	}

	handleModal = () => {

		let temp = {
			activity_id: '',
			category_id: '',
			city_list_id: '',
		}

		this.setState({
			isError: false,
			isOpen: false,
			isEdit: false,
			mappingDetails: temp

		})
	}

	handleDeleteToggle = (id) => {

		this.setState({
			id
		})

		this.toggleDelete("ConfirmModalOpenStatus")

	}


	handleDelete = () => {

		let { id } = this.state

		this.props.deleteActivityMapping(id).then(() => {

			this.props.getCategoryMappingListDetails({ pageNo: 1 })

			this.toggleDelete("ConfirmModalOpenStatus")

		})

	}

	toggleDelete = (name) => {
		this.setState({
			[name]: !this.state[name]
		})
	}


	render() {

		let { details, headerDetails, filter, selectedFilter, mappingDetails, isError, isOpen, isEdit, ConfirmModalOpenStatus, activityList, categoryList, cityList } = this.state
		let dropDownLists = {
			activityList, categoryList, cityList
		}

		let { mappingActivityLists = {} } = this.props

		let { list = [], pageMeta = {} } = mappingActivityLists;

		let IsEmpty = list.length > 0


		return (
			<div>
				<div className="sair-pg-header">
					<h4 className="sair-pg-title align-self-center">
						<span className="pg-title-icon">
							<span className="feather-icon">
								<svg
									xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
									fill="none" stroke="currentColor" className="feather feather-align-left">
									<line x1="17" y1="10" x2="3" y2="10"></line>
									<line x1="21" y1="6" x2="3" y2="6"></line>
									<line x1="21" y1="14" x2="3" y2="14"></line>
									<line x1="17" y1="18" x2="3" y2="18"></line>
								</svg>
							</span>
						</span>Mapping Activity
					</h4>
					<div className="col-auto ">
						<button className="btn btn-primary btn-sm"
							onClick={() => this.handleAdd()}
						>Add Mapping Activity</button>
					</div>
				</div>
				<section className="sair-sec-wrapper">
					<div className="row">
						<div className="col-sm">
							<div className="row no-gutters">
								<h5 className="sair-sec-title align-self-center"> Mapping Activity List</h5>
								<div className="ml-auto d-flex align-items-center">
									{/* <UncontrolledDropdown setActiveFromChild className="filter-dropdown">
										<DropdownToggle tag="a" className="custom-caret dropdown-toggle-link">
											Filter by: {selectedFilter}
										</DropdownToggle>
										<DropdownMenu>
											{filter.map(({ label, value }, index) => {
												return (
													<DropdownItem
														onClick={e => this.handleFilter(label, value, "filter")}
														key={index}
													>
														{label}
													</DropdownItem>

												)
											})}
										</DropdownMenu>
									</UncontrolledDropdown> */}

									<div className="search-box position-relative  ml-3">

										{/* <Filters
											queryHandler={(query) => this.handleFilter(query)}
											isDropDownFilter={false}
										/> */}
									</div>
								</div>
							</div>
							<div className="table-wrap mt-3">
								<TableWrapper
									headerDetails={headerDetails}
									isEmpty={IsEmpty}
									pageMeta={pageMeta}
									queryHandler={(query) => this.handleFilter(query)}
								>
									{list.map((item, index) => {

										let { id, status, Activity = [], Category = [], CityList = [] } = item



										return (
											<tr
												key={index}  >
												<td>{getSNo(pageMeta, index)}</td>
												<td>{Activity ? Activity.title : '-'}</td>
												<td>{Category ? Category.title : '-'}</td>
												<td>{CityList ? CityList.city_name : '-'}</td>
												<td>{this.requestStatus(status)}</td>
												<td>
													<a
														className="mr-25"
														onClick={e => this.handleEdit(index)}
													>
														<i className="icon-pencil  text-primary cursor-pointer"
														></i>
													</a>
													<a ><i
														className="icon-trash txt-danger text-primary cursor-pointer"
														onClick={e => this.handleDeleteToggle(id)}
													></i></a>
												</td>

											</tr>

										)

									})}


								</TableWrapper>
							</div>
						</div>
					</div>
				</section>



				<SliderOverlay isOpen={isOpen} toggle={this.handleModal} size='30%'>
					<div className="side-slider h-100 position-relative">
						<div className="h-100 flex-with-center">
							<MappingActivityModal
								isError={isError}
								toggle={this.handleModal}
								isEdit={isEdit}
								modalDetails={details}
								dropDownLists={dropDownLists}
							/>
						</div>

					</div>
				</SliderOverlay>

				<ConfirmModal
					keyName="ConfirmModalOpenStatus"
					toggle={this.toggle}
					isOpen={ConfirmModalOpenStatus}
					handleSubmit={() => this.handleDelete()}
					submitText='Delete'
				>
					<h5>
						Are you sure want to delete Category?
					</h5>
				</ConfirmModal>

			</div>
		)
	}
}

const mapStateToProps = state => {

	return {
		mappingActivityLists: state.activity.mappingActivityLists,
		categoryMappingDropDownLists: state.activity.categoryMappingDropDownLists

	}


};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		getCategoryMappingListDetails,
		getCategoryMappingDropDown,
		deleteActivityMapping,
	}, dispatch)
};

let actions = ['getCategoryMappingListDetails', 'getCategoryMappingDropDown']

let component = LoaderWrapper(MappingActivityClass)({ actions })



export const MappingActivity = connect(mapStateToProps, mapDispatchToProps)(component)

